import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import VerbHeading from '../../../shared/components/VerbHeading';
import VerbText from '../../../shared/components/VerbText';
import log from '../../../shared/utils/log';

export default class RecommendedPathwaysSection extends PureComponent {
    static propTypes = {
        pathwayOptions: PropTypes.arrayOf(PropTypes.object),
        company: PropTypes.shape({
            customDiscover: PropTypes.object
        }),
        userPathway: PropTypes.object,
        userPathways: PropTypes.array,
        history: PropTypes.object.isRequired,
    };

    _getPathwaysToRender = () => {
        const { pathwayOptions, userPathway = {}, userPathways } = this.props;

        const pathwayRecommendationOptions = [...pathwayOptions].filter((pathway) => !!pathway);
        if (!pathwayRecommendationOptions.length) {
            log.warn(
                `No pathway recommendations. [UserPathway: ${JSON.stringify(userPathway)}] [Options: ${JSON.stringify(
                    pathwayOptions
                )}]`
            );
            return [];
        }

        let pathwaysToRender = [...pathwayOptions];
        userPathways.forEach((userPathway) => {
            // don't show/recommend any pathways the user has already started
            if (userPathway) {
                const removeIdx = pathwaysToRender.findIndex((path) => path._id === userPathway.pathwayId);
                if (removeIdx) {
                    pathwaysToRender.splice(removeIdx, 1);
                }
            }
        });
        pathwaysToRender = pathwaysToRender.sort((a, b) => (a.name > b.name) - (a.name < b.name));
        return pathwaysToRender.slice(0, 2);
    };

    _makePathwayCards = (pathwaysToRender) => {
        return (
            <div className={'explore-pathway'}>
                <div className={'col-12'}>
                    <div className={'row'}>
                        {pathwaysToRender.map((path) =>
                            path && path._id ? (
                                <div
                                    className={'col-12 col-sm-12 col-md-6 pathway-card'}
                                    onClick={() => {
                                        return this.props.history.push(
                                            `/home?pathwayView=detail&pathwayId=${path._id}`
                                        );
                                    }}
                                    key={path._id}
                                >
                                    <div className={'row-title'}>
                                        <VerbHeading
                                            defaultMessage={`${path.name}`}
                                            className={'path-title'}
                                            hNumber={3}
                                        />
                                    </div>
                                    <div className={'row'}>
                                        <div className={'row-details col-10'}>
                                            <p>{path.subtitle}</p>
                                        </div>
                                        <div className={'col-1 pathway-arrow'}>
                                            <span className={'fal fa-chevron-right pathway-chevron-right'}></span>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        )}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { pathwayOptions = [] } = this.props;

        if (!pathwayOptions || !pathwayOptions.length) {
            return null;
        }

        const pathwaysToRender = this._getPathwaysToRender();
        if (!pathwaysToRender || !pathwaysToRender.length) {
            return null;
        }

        return (
            <div className={'col-12 up-next-container'}>
                <div className={'container'}>
                    <VerbHeading
                        className={'section-heading'}
                        hNumber={5}
                        messageId={'EXPLORE_A_NEW_PATHWAY'}
                        defaultMessage={'EXPLORE A NEW PATHWAY'}
                    />
                    <div className={'description-text section-description'}>
                        <VerbText
                            messageId={'PATHWAY_INTERSTITIAL_UP_NEXT_TEXT'}
                            defaultMessage={'Congratulations on your big accomplishment! What’s next for you?'}
                        />
                    </div>
                    {this._makePathwayCards(pathwaysToRender)}
                </div>
            </div>
        );
    }
}
